import BecameWorker from './BecameWorker';

export default BecameWorker;
